// extracted by mini-css-extract-plugin
export default {"wrapper":"loader_wrapper__FmbP7","cardLoader":"loader_cardLoader__+6tRP","loader":"loader_loader__fgGu9","bounce2":"loader_bounce2__70uge"};